// 申请类型
const applyType: any = {
  X_POOL_NUMBER_IMPORT: "X池号码导入申请",
};

// 审批状态
const approvalStatus: any = {
  PENDING: "审批中",
  APPROVED: "已通过",
  REJECTED: "已拒绝",
  CANCELED: "已撤回",
  DELETED: "已删除",
};
// 审批状态
const recordStatus: any = {
  AUDITING: "审批中",
  AUDIT_APPROVED: "审核通过",
  AUDIT_REJECTED: "审核不通过"
};

//号池状态
const poolStatus: any = {
  0: "禁用",
  1: "启用",
};

//号码状态
const status: any = {
  1: "使用中",
  2: "X池禁用",
  3: "平台禁用 ",
};

//开通状态
const activateStatus: any = {
  HANDLING: "处理中",
  SUCCESS: "成功",
  FAIL: "失败 ",
};

//入池状态
const enterPoolStatus: any = {
  true: "成功",
  false: "失败",
};

//视频状态
const videoStatus: any = {
  1: "已上架",
  2: "已下架",
  3: "初审核中",
  4: "审核未通过",
  5: "删除中",
  6: "终审中",
  7: "AI审核中",
};

//视频标签
const videoTag: any = {
  1: "游戏",
  2: "广告",
  3: "保险",
  4: "理财",
  5: "政策",
  6: "售后",
  7: "其他",
};

//X号新增类型
const xapplyType: Array<{ value: string; label: string }> = [
  { value: "XPOOL_NUMBER_IMPORT", label: "新增X池号码" },
  { value: "XPOOL_NUMBER_IMPORT_CUSTOMER", label: "新增X池号码(自带)" },
];
//X号申请状态
const xapplystatus: Array<{ value: string; label: string }> = [
  { value: "RECEIVED", label: "待受理" },
  { value: "COMPLETED", label: "已通过" },
  { value: "RETURNED", label: "已退回" },
  { value: "PROCESSING", label: "受理中" },
];

//来电名片模版状态
const templateStatus: any = {
  1: "初审中",
  2: "终审中",
  3: "审核失败",
  4: "启用",
  5: "禁用",
};

//来电名片模版审核结果
const templateAuditResult: any = {
  1: "成功",
  2: "失败",
};
//客户经理
const customerManagerCode: Array<{ value: string; label: string }> = [
  { label: "AM001", value: "张华" },
  { label: "AM002", value: "曹宇恒" },
  { label: "AM003", value: "陈峰" },
  { label: "AM004", value: "张颉" },
];
//客户经理
const recordingType: Array<{ value: string; label: string }> = [
  { value: "1", label: "单轨录音" },
  { value: "2", label: "双轨录音" },
  { value: "3", label: "单轨录音组合存储" }
];
const priority: Array<{ value: string; label: string }> = [
  { value: "NORMAL", label: "NORMAL" },
  { value: "IDLE", label: "IDLE" },
  { value: "HIGH", label: "HIGH" }
];
const booleanStatus: Array<{ value: boolean; label: string }> = [
  { value: true, label: "启用" },
  { value: false, label: "禁用" }
];
const booleanResult: Array<{ value: boolean; label: string }> = [
  { value: true, label: "审核通过" },
  { value: false, label: "审核不通过" }
];
const languageStatus: Array<{ value: string; label: string }> = [
  { value: 'DRAFT', label: "草稿" },
  { value: 'WAIT_AUDIT', label: "待审核" },
  { value: 'AUDIT_ACCEPT', label: "审核通过" },
  { value: 'AUDIT_REJECTED', label: "审核不通过" },
  { value: 'AUDIT_ACCEPT_EXPIRED', label: "审核通过（已过期）" },
];
const dictionary = {
  booleanResult,
  languageStatus,
  booleanStatus,
  priority,
  recordStatus,
  recordingType,
  customerManagerCode,
  xapplyType,
  xapplystatus,
  approvalStatus,
  applyType,
  poolStatus,
  status,
  activateStatus,
  enterPoolStatus,
  videoStatus,
  videoTag,
  templateStatus,
  templateAuditResult
};

export default dictionary;
